document.querySelectorAll(".searchResultsFiltersMobileButton").forEach(el => {
    el.addEventListener("click", function (e) {
        // Toggle Button
        this.classList.toggle("active");

        // Toggle menu
        document.querySelector(`${this.dataset.target}`).classList.toggle("open");
    });
});

// Desktop Price Range
document.querySelector("#searchResultsFiltersDesktop .productFiltersGroupContentPriceRangeSlider").addEventListener("input", function (e) {
    const {left, right} = e.detail;
    const priceRangeContainerEl = document.querySelector("#searchResultsFiltersDesktop .productFiltersGroupContentPriceRange");
    priceRangeContainerEl.querySelector(`input[name="filter.v.price.gte"]`).value = left;
    priceRangeContainerEl.querySelector(`input[name="filter.v.price.lte"]`).value = right;
});

// Mobile Price Range
document.querySelector("#searchResultsFiltersMobile .productFiltersGroupContentPriceRangeSlider").addEventListener("input", function (e) {
    const {left, right} = e.detail;
    const priceRangeContainerEl = document.querySelector("#searchResultsFiltersMobile .productFiltersGroupContentPriceRange");
    priceRangeContainerEl.querySelector(`input[name="filter.v.price.gte"]`).value = left;
    priceRangeContainerEl.querySelector(`input[name="filter.v.price.lte"]`).value = right;
});